<template>
  <CenterContent size="xs12 sm8 md6 lg4">
    <v-card class="pa-8 text-center" elevation="2">
      <div class="mb-6">
        <v-icon size="80" color="error" class="mb-4">bx bx-shield-x</v-icon>
        <h2 class="text-h5 font-weight-bold mb-2">Access Denied</h2>
        <p class="text-body-1 text--secondary">
          You don't have permission to access this page.
        </p>
      </div>
      
      <v-divider class="my-6"></v-divider>
      
      <div class="text-left mb-6">
        <p class="text-body-2 mb-2">
          <strong>What you can do:</strong>
        </p>
        <ul class="text-body-2 text--secondary pl-4">
          <li>Contact your administrator to request access</li>
          <li>Check if you're logged in with the correct account</li>
          <li>Return to the home page and try a different section</li>
        </ul>
      </div>
      
      <Button
        title="Go to Home"
        prepend-icon="bx bx-home"
        @onClick="goToHome"
        color="primary"
        block
      />
    </v-card>
  </CenterContent>
</template>

<script>
import CenterContent from "@/base_lib/components/container/CenterContent"
import Button from "@/base_lib/components/form/Button"
import router from "@/router"

export default {
  name: "PermissionError",
  components: {
    CenterContent,
    Button
  },
  methods: {
    goToHome() {
      router.push({ name: 'Welcome' })
    }
  }
}
</script>

<style scoped>
ul {
  list-style-type: disc;
}
</style>

